export default __webpack_public_path__ + "static/media/p54.46e62f97.jpg";